import React, { type FC, type MutableRefObject, useRef } from 'react';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/Shared/Inputs';
import CloseIcon from '@mui/icons-material/Close';

import '../../../components/CaseModelInfoDialog/CaseModelInfoDialog.scss';

interface DeleteAddressModalProps {
    open: boolean;
    onClose: () => void;
    btnAction: () => void;
}

export const DeleteAddressModal: FC<DeleteAddressModalProps> = (props) => {
    const { open, onClose, btnAction } = props;
    const { t } = useTranslation(['emergencyContact', 'common'], { useSuspense: false });
    const modalRef = useRef<HTMLDivElement|null>(null) as MutableRefObject<HTMLDivElement|null>;

    return (
        <Modal open={open} ref={modalRef} onClose={onClose} className='dialog_wrapper' role="dialog" aria-modal
            aria-labelledby="model_info_dialog_title" aria-describedby="model_info_dialog_content">
            <div className="dialog_surface">
                <div className="dialog_title_wrapper">
                    <h2 id="model_info_dialog_title">
                        {t('confirm_delete_current_info')}
                    </h2>
                    <IconButton aria-label={t('common:close')} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className="dialog_content_wrapper" id="model_info_dialog_content">
                    {t("all_previous_address_info_will_be_deleted")}
                </div>
                <div className="dialog_actions_wrapper">
                    <Button variant="outline" onClick={onClose}>
                        {t('common:cancel')}
                    </Button>
                    <Button variant="opaque" onClick={btnAction}>{t("yes_remove")}</Button>
                </div>
            </div>
        </Modal>
    )
}
